import { schema } from "normalizr";
import { wfpDivisionsTypes } from "../types";
import Resource from "./resource";

const wfpDivisionSchema = new schema.Entity("wfpDivisions");

export default new Resource("/divisions", wfpDivisionsTypes, wfpDivisionSchema);
